module.exports = __webpack_public_path__ + "static/media/SV.e916ec9c.svg";